import { render, staticRenderFns } from "./m-form-address-en.vue?vue&type=template&id=6a7f789e&scoped=true&"
import script from "./m-form-address-en.vue?vue&type=script&lang=js&"
export * from "./m-form-address-en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7f789e",
  null
  
)

export default component.exports